import React, {useState, useEffect} from "react";
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import HC3D from "highcharts/highcharts-3d";
import {
    INTERACTION_COLOR_HIGHCHART,
    SYMBOLS_HIGHCHART
} from "../utils/colorMap.js"
import {getDetailFromChartClick} from "../utils/getdetails";

HC3D(Highcharts);

export default function Scatter3D({mainData, firstRowDivHeight, results, onNestedRowClick, pdb, folder, sortOnClick}) {

    //,Res. Name 1,Res. Number 1,Chain 1,Res. Name 2,Res. Number 2,Chain 2,Type of Interactions
    const [options, setOptions] = useState(null);

    const getSeries = (mainData) => {
        let series = [];
        let data = {'ALL':{data: []}};

        mainData.forEach(row => {
            const interactions = row[7].split(';')
            interactions.forEach(interaction => {

                if (!interaction || !interaction.trim()) {
                    return;
                }

                interaction = interaction.replace('*', '').trim();
                if (!data[interaction]) {
                    data[interaction] = {data: []};
                }

                data[interaction].data.push([parseInt(row[2]), 0, parseInt(row[5]), row]);
                data['ALL'].data.push([parseInt(row[2]), 0, parseInt(row[5]), row]);
            });
        });

        Object.keys(data).forEach((key, index) => {
            series.push({
                name: key,
                data: data[key].data.map(e => {
                    e[1] = index;
                    return [e[0], e[1], e[2]];
                }),
                originalData: data[key],
                marker: {
                    symbol: SYMBOLS_HIGHCHART[key],
                    fillColor: INTERACTION_COLOR_HIGHCHART[key]
                },
                point: {
                    events: {
                        click: async function () {
                            const serie = series.find(s => s.name === this.series.name)
                            const elem = serie.originalData.data[this.index];
                            if (elem && this.series.name !== 'ALL') {
                                const row = elem[3];
                                const res = await getDetailFromChartClick(folder, pdb, this.series.name, row);
                                const firstRow = res[0];
                                sortOnClick(firstRow[2], firstRow[3], firstRow[1], firstRow[5], firstRow[6], firstRow[4]);
                                onNestedRowClick(res[0], this.series.name);
                                document.getElementById("molstar").scrollIntoView({behavior: 'smooth'});
                            }
                        }
                    }
                }
            });
        });
        return series;
    }

    useEffect(() => {
        const series = getSeries(mainData);

        const options = {
            chart: {
                renderTo: "container",
                type: "scatter",
                height: firstRowDivHeight,
                options3d: {
                    enabled: true,
                    alpha: 15,
                    beta: 45,
                    depth: 500,
                    viewDistance: 10,
                    frame: {
                        bottom: {size: 0.5, color: 'rgba(0,0,0,0.02)'},
                        back: {size: 0.5, color: 'rgba(0,0,0,0.04)'},
                        side: {size: 0.5, color: 'rgba(0,0,0,0.06)'}
                    },
                },
                events: {
                    load: function () {
                        const chart = this;
                        // Enable dragging
                        Highcharts.addEvent(chart.container, 'mousedown', function (e) {
                            chart.mouseDown = true;
                            chart.startX = e.clientX;
                            chart.startY = e.clientY;
                            chart.alpha = chart.options.chart.options3d.alpha;
                            chart.beta = chart.options.chart.options3d.beta;
                        });

                        Highcharts.addEvent(document, 'mousemove', function (e) {
                            if (chart.mouseDown) {
                                const deltaX = e.clientX - chart.startX;
                                const deltaY = e.clientY - chart.startY;
                                chart.options.chart.options3d.alpha = chart.alpha - deltaY
                                    * 0.1;
                                chart.options.chart.options3d.beta = chart.beta + deltaX * 0.1;
                                chart.redraw(false);
                            }
                        });

                        Highcharts.addEvent(document, 'mouseup', function () {
                            chart.mouseDown = false;
                        });
                    }
                },
            },
            plotOptions: {
                column: {
                    depth: 25
                }
            },
            tooltip: {
                formatter: function () {
                    const serie = series.find(s => s.name === this.series.name)
                    const elem = serie.originalData.data[this.point.index];
                    if (elem) {
                        const row = elem[3];
                        return `${row[1]}${row[2]}_${row[3]} - ${row[4]}${row[5]}_${row[6]}`;
                    }
                }
            },
            title: {
                text: 'Atomic Interactions <br/> 3D Contact Map'
            },
            subtitle: {
                text:
                    ''
            },
            xAxis: {
                gridLineWidth: 1,
                title: {
                    text: results.mol2 ? `${results.mol2}` : `CHAIN ${mainData[0][6]}`,
                    offset: 60,
                    style: {
                        fontWeight: 'bold',
                    }
                }
            },
            yAxis: {
                labels: {
                    formatter: function () {
                        if (this.chart.series[this.value]) {
                            return this.chart.series[this.value].name;
                        }
                        return ''
                    },
                    step: 1
                },
                title: {
                    text: ''
                },
                tickInterval: 1
            },
            zAxis: {
                title: {
                    text: results.mol1 ? `${results.mol1}` : `CHAIN ${mainData[0][3]}`,
                    offset: 60,
                    style: {
                        fontWeight: 'bold',
                    }
                },
            },
            series: series,
            /*legend: {
              layout: 'vertical',
              align: 'right',
              verticalAlign: 'middle',
            }*/
        };

        setOptions(options);

    }, [mainData, firstRowDivHeight]);

    return (
        <>
            {options && (
                <div style={{paddingLeft: '40px', paddingRight: '40px'}}>
                    <HighchartsReact highcharts={Highcharts} options={options}/>
                </div>
            )}
        </>
    )
}